import "./Portfolio.scss";

export default function Portfolio() {
  return (
    <section className="portfolio--section" id="MyPortfolio">
      <div className="portfolio--container-box">
        <div className="portfolio--container">
          <p className="sub--title">Recent Projects</p>
          <h2 className="section--heading">My Portfolio</h2>
        </div>
        <div>
          <a
            href="https://github.com/mohzaf66"
            className="btn btn-github"
            target="_blank"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 33 33"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.3333 0.166748C7.50028 0.166748 0.333252 7.33378 0.333252 16.1667C0.333252 24.9997 7.50028 32.1667 16.3333 32.1667C25.1489 32.1667 32.3333 24.9997 32.3333 16.1667C32.3333 7.33378 25.1489 0.166748 16.3333 0.166748ZM26.9016 7.54202C28.8105 9.8674 29.9559 12.8348 29.9906 16.0452C29.5394 15.9585 25.0274 15.0387 20.4808 15.6114C20.3767 15.3858 20.2899 15.1428 20.1858 14.8999C19.9081 14.2405 19.5958 13.5637 19.2834 12.9216C24.3159 10.8739 26.6066 7.9238 26.9016 7.54202ZM16.3333 2.52684C19.804 2.52684 22.9797 3.82836 25.3919 5.96285C25.1489 6.30992 23.0838 9.06914 18.2248 10.8912C15.9862 6.77846 13.5047 3.41187 13.1229 2.89126C14.1467 2.64831 15.2227 2.52684 16.3333 2.52684ZM10.5199 3.811C10.8843 4.2969 13.3138 7.68085 15.5871 11.7068C9.20093 13.4075 3.56102 13.3728 2.95364 13.3728C3.83867 9.13855 6.70201 5.61577 10.5199 3.811ZM2.65863 16.1841C2.65863 16.0452 2.65863 15.9064 2.65863 15.7676C3.24865 15.7849 9.87772 15.8717 16.6977 13.824C17.0969 14.5875 17.4613 15.3684 17.8084 16.1493C17.6348 16.2014 17.4439 16.2535 17.2704 16.3055C10.2248 18.5788 6.47642 24.7914 6.16405 25.312C3.99485 22.8999 2.65863 19.6895 2.65863 16.1841ZM16.3333 29.8413C13.1749 29.8413 10.2595 28.7654 7.95147 26.9606C8.19442 26.4574 10.971 21.1125 18.676 18.4227C18.7107 18.4053 18.7281 18.4053 18.7628 18.388C20.689 23.3684 21.47 27.5506 21.6782 28.748C20.0296 29.4595 18.2248 29.8413 16.3333 29.8413ZM23.9515 27.4986C23.8127 26.6656 23.0838 22.6743 21.2964 17.7632C25.5828 17.0864 29.3311 18.1971 29.7997 18.3533C29.2097 22.1537 27.0231 25.4335 23.9515 27.4986Z"
                fill="currentColor"
              />
            </svg>
            Visit My GitHub
          </a>
        </div>
      </div>


       {/* card-start */}
       <div class="portfolio-card mb-3">
          <div class="row">
            <div class="col-md-7">
              <img
                src="../../../img/ukaligner.webp"
                className="card-img"
                alt="..."
              />
            </div>
            <div class="col-md-5">
              <div class="card-body">
                <div className="content">
                <h4 class="card-title">UK Aligners</h4>
                <p class="card-text">
                  This is a Dental Management Software to manage the staffing, services, time scheduling, appoinments, bills, payments and all.
                </p>
                <div class="card-tech">
                  <small class="text-muted">Technologies Used: </small>
                  <div className="card-icons">
                <img src="https://cdn-icons-png.flaticon.com/512/732/732212.png" alt="icon" />
                <img src="https://w7.pngwing.com/pngs/509/571/png-transparent-cascading-style-sheets-logo-css3-html-web-development-world-wide-web-blue-angle-web-design.png" alt="icon" />
                <img src="https://seeklogo.com/images/J/javascript-logo-8892AEFCAC-seeklogo.com.png" alt="icon" />
                <img src="https://blog.knoldus.com/wp-content/uploads/2021/10/django-logo-big-removebg-preview.png" alt="icon" />
                <img src="https://static-00.iconduck.com/assets.00/bitbucket-icon-512x460-aj2zdfts.png" alt="icon" />
              </div>
                </div>
                </div>
                <div className="card-btns">
                <a href="https://www.ukaligners.com/" target= "_blank" className="btn btn-primary">Demo</a>
                <a href="https://bitbucket.org/zprofession/ukaligners/src/master/UKAligners/" target="_blank" className="btn btn-primary">BitBucket</a>
                </div>
              </div>
            </div>
          </div>
        </div>
                {/* card-end */}

       {/* card-start */}
       <div class="portfolio-card mb-3">
          <div class="row">
            <div class="col-md-7">
              <img
                src="../../../img/perfume.webp"
                className="card-img"
                alt="..."
              />
            </div>
            <div class="col-md-5">
              <div class="card-body">
                <div className="content">
                <h4 class="card-title">Perfume Borong</h4>
                <p class="card-text">
                  This is a E-commerce website that is selling Local made perfumes and scents in Malaysia.
                </p>
                <div class="card-tech">
                  <small class="text-muted">Technologies Used: </small>
                  <div className="card-icons">
                
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png" alt="icon" />
                <img src="https://seeklogo.com/images/N/nodejs-logo-FBE122E377-seeklogo.com.png" alt="icon" />
                <img src="https://www.svgrepo.com/show/354113/nextjs-icon.svg" alt="icon" />
                <img src="https://cdn-icons-png.flaticon.com/512/25/25231.png" alt="icon" />
              </div>
                </div>
                </div>
                <div className="card-btns">
                <a href="https://perfumeborongmalaya.my/" target= "_blank" className="btn btn-primary">Demo</a>
                <a href="https://bitbucket.org/zprofession/ukaligners/src/master/UKAligners/" target="_blank" className="btn btn-primary disabled">Github</a>
                </div>
              </div>
            </div>
          </div>
        </div>
                {/* card-end */}
      
    {/* card-start */}
    <div class="portfolio-card mb-3">
          <div class="row">
            <div class="col-md-7">
              <img
                src="../../../img/boston.webp"
                className="card-img"
                alt="..."
              />
            </div>
            <div class="col-md-5">
              <div class="card-body">
                <div className="content">
                <h4 class="card-title">Boston Dental</h4>
                <p class="card-text">
                  Boston Dental is a dental agency Providing high quality dental treatment services in US and many other countries.
                </p>
                <div class="card-tech">
                  <small class="text-muted">Technologies Used: </small>
                  <div className="card-icons">
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png" alt="icon" />
                <img src="https://ww1.freelogovectors.net/wp-content/uploads/2019/02/sass-logo.png?lossy=1&w=2560&ssl=1" alt="icon" />
                <img src="https://seeklogo.com/images/N/nodejs-logo-FBE122E377-seeklogo.com.png" alt="icon" />
                <img src="https://cdn-icons-png.flaticon.com/512/25/25231.png" alt="icon" />
              </div>
                </div>
                </div>
                <div className="card-btns">
                <a href="https://www.bostondental.com/" target= "_blank" className="btn btn-primary ">Demo</a>
                <a href="" target="_blank" className="btn btn-primary disabled">BitBucket</a>
                </div>
              </div>
            </div>
          </div>
        </div>
                {/* card-end */}
    

        {/* card-start */}
        <div class="portfolio-card mb-3">
          <div class="row">
            <div class="col-md-7">
              <img
                src="../../../img/ultramod.webp"
                className="card-img"
                alt="..."
              />
            </div>
            <div class="col-md-5">
              <div class="card-body">
                <div className="content">
                <h4 class="card-title">Ultra Modern</h4>
                <p class="card-text">
                  This is a healthcare management software to manage the staffing, time scheduling, appoinments, payments and all.
                </p>
                <div class="card-tech">
                  <small class="text-muted">Technologies Used: </small>
                  <div className="card-icons">
                <img src="https://cdn-icons-png.flaticon.com/512/732/732212.png" alt="icon" />
                <img src="https://w7.pngwing.com/pngs/509/571/png-transparent-cascading-style-sheets-logo-css3-html-web-development-world-wide-web-blue-angle-web-design.png" alt="icon" />
                <img src="https://seeklogo.com/images/J/javascript-logo-8892AEFCAC-seeklogo.com.png" alt="icon" />
                <img src="https://blog.knoldus.com/wp-content/uploads/2021/10/django-logo-big-removebg-preview.png" alt="icon" />
                <img src="https://static-00.iconduck.com/assets.00/bitbucket-icon-512x460-aj2zdfts.png" alt="icon" />
              </div>
                </div>
                </div>
                <div className="card-btns">
                <a href="" target= "_blank" className="btn btn-primary disabled">Demo</a>
                <a href="https://bitbucket.org/zprofession/pinkcow/src/master/Pinkcow/" target="_blank" className="btn btn-primary">BitBucket</a>
                </div>
              </div>
            </div>
          </div>
        </div>
                {/* card-end */}
                
                
        {/* card-start */}
        <div class="portfolio-card mb-3">
          <div class="row">
            <div class="col-md-7">
              <img
                src="../../../img/inchipde.webp"
                className="card-img"
                alt="..."
              />
            </div>
            <div class="col-md-5">
              <div class="card-body">
                <div className="content">
                <h4 class="card-title">INCHIP</h4>
                <p class="card-text">
                  INCHIP is an IT-Leasing ecommerce website that is selling Laptops, Desktops, CPUs, Monitors, and Spare Parts.
                </p>
                <div class="card-tech">
                  <small class="text-muted">Technologies Used: </small>
                  <div className="card-icons">
                <img src="https://cdn-icons-png.flaticon.com/512/732/732212.png" alt="icon" />
                <img src="https://w7.pngwing.com/pngs/509/571/png-transparent-cascading-style-sheets-logo-css3-html-web-development-world-wide-web-blue-angle-web-design.png" alt="icon" />
                <img src="https://seeklogo.com/images/J/javascript-logo-8892AEFCAC-seeklogo.com.png" alt="icon" />
                <img src="https://blog.knoldus.com/wp-content/uploads/2021/10/django-logo-big-removebg-preview.png" alt="icon" />
                <img src="https://static-00.iconduck.com/assets.00/bitbucket-icon-512x460-aj2zdfts.png" alt="icon" />
              </div>
                </div>
                </div>
                <div className="card-btns">
                <a href="https://inchip.de/" target= "_blank" className="btn btn-primary">Demo</a>
                <a href="https://bitbucket.org/zprofession/pinkcow/src/master/Pinkcow/" target="_blank" className="btn btn-primary disabled">Github</a>
                </div>
              </div>
            </div>
          </div>
        </div>
                {/* card-end */}

       
    </section>
  );
}
